module.exports = __webpack_public_path__ + "static/media/bnb.e6853843.png";